import React from 'react'
import { parentMutationInput } from 'lib/helpers/parent/forms'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      updateParent, // via withMutation
      form, // via withRedux
      parent // via withQuery
    } = props

    // perform GraphQL mutation
    const handleSubmit = e => {
      e.preventDefault()

      updateParent({
        variables: {
          parentId: parent.id,
          input: parentMutationInput({parent, form})
        }
      })
    }

    return <WrappedComponent handleSubmit={handleSubmit} {...props} />
  }
}

export default withEventHandlers
